import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import { Layout } from "@/components/layout/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import HomePage from "@/pages/Home";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import ForgotPasswordPage from "@/pages/ForgotPassword";
import ResetPasswordPage from "@/pages/ResetPassword";
import CompaniesPage from "@/pages/Companies";
import CompanyProfilePage from "@/pages/CompanyProfile";
import CommunityPage from "@/pages/Community";
import PostDetailPage from "@/pages/PostDetail";
import PropertiesPage from "@/pages/Properties";
import PropertyDetailPage from "@/pages/PropertyDetail";
import ProjectDetailPage from "@/pages/ProjectDetail";
import PostJobPage from "@/pages/PostJob";
import DashboardPage from "@/pages/Dashboard";
import JobQuotesPage from "@/pages/JobQuotes";
import BusinessWorkspacePage from "@/pages/BusinessWorkspace";
import { MessagesPanel } from "@/components/MessagesPanel";
import BusinessRegisterPage from "@/pages/BusinessRegister";
import AdminPage from "@/pages/Admin";
import StaticPage from "@/pages/StaticPage";
import NotFoundPage from "@/pages/NotFound";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/companies" element={<CompaniesPage />} />
            <Route path="/companies/:slug" element={<CompanyProfilePage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/community/posts/:id" element={<PostDetailPage />} />
            <Route path="/properties" element={<PropertiesPage />} />
            <Route path="/properties/:slug" element={<PropertyDetailPage />} />
            <Route path="/projects/:slug" element={<ProjectDetailPage />} />
            <Route path="/post-a-job" element={<PostJobPage />} />
            <Route path="/how-it-works" element={<StaticPage slug="how-it-works" />} />
            <Route path="/for-businesses" element={<StaticPage slug="for-businesses" />} />
            <Route path="/about" element={<StaticPage slug="about" />} />
            <Route path="/contact" element={<StaticPage slug="contact" />} />
            <Route path="/terms" element={<StaticPage slug="terms" />} />
            <Route path="/privacy" element={<StaticPage slug="privacy" />} />
            <Route path="/community-guidelines" element={<StaticPage slug="community-guidelines" />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/dashboard/jobs" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/dashboard/jobs/:id" element={<ProtectedRoute><JobQuotesPage /></ProtectedRoute>} />
            <Route path="/dashboard/messages" element={<ProtectedRoute><div className="propora-container py-10"><h1 className="font-display font-extrabold text-4xl text-[#0B1733] mb-6">Messages</h1><MessagesPanel /></div></ProtectedRoute>} />
            <Route path="/business/register" element={<ProtectedRoute><BusinessRegisterPage /></ProtectedRoute>} />
            <Route path="/business/:companyId" element={<ProtectedRoute><BusinessWorkspacePage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminPage /></ProtectedRoute>} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
